module.exports = __webpack_public_path__ + "static/media/smileRating1Active.5d3399ba.svg";